if (!customElements.get('sample-product-form')) {
  customElements.define(
    'sample-product-form',
    class SampleProductForm extends ProductForm {
      constructor() {
        super();
        this.form = this.querySelector('.js-sample-product-form');
        if (this.form) {
          const idInput = this.form.querySelector('[name="id"]');
          idInput.required = true;

          if (theme.settings.afterAddToCart !== 'no-js') {
            this.submitBtn = this.querySelector('[name="add"]');
            this.form.addEventListener('submit', this.handleSubmit.bind(this));
          }
        }
      }
    }
  )
};